module.exports = __webpack_public_path__ + "img/logo.de67aa83.svg";